import { Injectable } from '@angular/core';
import { LanguageRepository } from './language.repository';

@Injectable({
  providedIn: 'root',
})
export class LanguageService implements LanguageRepository {
  private readonly browserLang: string;

  constructor() {
    this.browserLang = navigator.language || navigator.languages[0];
  }

  getBrowserLanguage(): string {
    return this.browserLang;
  }

  getLanguageCode(): string {
    return this.browserLang.split('-')[0];
  }
}
